import { audioDebugEnabled } from "./audio-debug";

function debugEnabled(): boolean {
  if (audioDebugEnabled()) return true;
  try {
    return localStorage.getItem("dashcamPttDebug") === "1";
  } catch {
    return false;
  }
}

export function pttLog(event: string, data?: Record<string, unknown>): void {
  if (!debugEnabled()) return;
  if (data) console.info("[ptt]", event, data);
  else console.info("[ptt]", event);
}
